export default __webpack_public_path__ + "static/web-analytics-light-mode-da81853de2c0df0d5c2ddadaf06603ac.mp4";